<div class="page-loader">
  <span class="icon"><i class="fa fa-spin fa-refresh"></i></span>
</div>
